const menuTabs = () => {
    const menuButtons = document.querySelectorAll(".cafe-menu-button");
    const menuContainer: HTMLElement = document.querySelector(".menu-horizontal-container");
    const overflowContainer: HTMLElement = document.querySelector(".menu-overflow-container");

    const breakfastMenu: HTMLElement = document.querySelector(".menu[data-index='0']");
    const lunchMenu: HTMLElement = document.querySelector(".menu[data-index='1']");
    const drinksMenu: HTMLElement = document.querySelector(".menu[data-index='2']");

    const menus = [breakfastMenu, lunchMenu, drinksMenu]

    let menuHeights: { [key: number]: number } = {
        0: breakfastMenu.scrollHeight,
        1: lunchMenu.scrollHeight,
        2: drinksMenu.scrollHeight,
    };

    const menuOptions: { [key: number]: string } = {
        0: "breakfast",
        1: "lunch",
        2: "drinks",
    };

    const handleButtonClick = (e: Event) => {
        const target = e.currentTarget as HTMLElement;
        const index = target.dataset.index;

        if (index === undefined) {
            menuContainer.setAttribute("data-active", "0");
            menuContainer.style.transform = "translateX(0)";
            adjustHeight(index)
            assignButtonEffect(target)
            setOpacity(parseInt(index))
            setBody(parseInt(index))
            return;
        }

        menuContainer.setAttribute("data-active", index.toString());
        const percentage = 100 * parseInt(index);
        menuContainer.style.transform = `translateX(-${percentage}%)`;
        assignButtonEffect(target)
        adjustHeight(index)
        setOpacity(parseInt(index))
        setBody(parseInt(index))
    }

    const setBody = (index?: number) => {
        const body = document.querySelector("body");
        body.setAttribute("data-menu", menuOptions[`${
            index ? index : 0
        }`]);
    }

    const adjustHeight = (index?: string) => {

        index ? overflowContainer.style.height = `${menuHeights[parseInt(index)]}px`
            : overflowContainer.style.height = `${menuHeights[0]}px`;

    }

    const setOpacity = (index?: number) => {
        index ?
            menus.forEach((menu, idx) => {
                idx === index ? menu.style.opacity = "100%" : menu.style.opacity = "0"
            })
            :
            menus.forEach((menu, idx) => {
                idx === undefined || idx === 0 ? menu.style.opacity = "100%" : menu.style.opacity = "0"
            })
    }

    const assignButtonEffect = (target: HTMLElement) => {
        menuButtons.forEach(button => {
            if (button === target) {
                button.classList.add("cafe-menu-button__active");
            } else {
                button.classList.remove("cafe-menu-button__active");
            }
        })
    }

    const recalculateMenuHeights = () => {

        overflowContainer.style.height = 'auto';

            menuHeights = {
                0: breakfastMenu.scrollHeight,
                1: lunchMenu.scrollHeight,
                2: drinksMenu.scrollHeight,
            };

            const activeIndex = menuContainer.getAttribute("data-active") || "0";

            adjustHeight(activeIndex);
    }

    adjustHeight();
    setOpacity();
    setBody();

    menuButtons.forEach(button => button.addEventListener("click", handleButtonClick));
    window.addEventListener("resize", recalculateMenuHeights)
}

export default menuTabs